import { useMemo } from 'react';
import { MARKET } from '../constants';
import { IS_T3_WEBSITE } from '../constants/environment';

interface UseCTATypesProps {
  firstButtonType: string;
  secondButtonType: string;
  legalTextType: string;
}

interface UseCTATypesInputProps {
  isAtYourDoor: boolean;
}

const FIRST_BUTTON_TYPES = {
  BOOK_A_TEST_DRIVE: 'BOOK_A_TEST_DRIVE',
  REQUEST_A_QUOTE: 'REQUEST_A_QUOTE',
  HOW_E_DEPOSIT_WORKS: 'HOW_E_DEPOSIT_WORKS',
  VISIT_DEALER_LISTING: 'VISIT_DEALER_LISTING',
  START_ONLINE_SHOPPING: 'START_ONLINE_SHOPPING',
};

const SECOND_BUTTON_TYPES = {
  CONTACT_DEALER: 'CONTACT_DEALER',
  REQUEST_A_QUOTE: 'REQUEST_A_QUOTE',
  PLACE_E_DEPOSIT: 'PLACE_E_DEPOSIT',
  RESERVED: 'RESERVED',
  VISIT_DEALER_LISTING: 'VISIT_DEALER_LISTING',
};

const BUTTON_LEGAL_NOTES = {
  PLACE_E_DEPOSIT: 'PLACE_E_DEPOSIT',
  VEHICLE_RESERVED: 'VEHICLE_RESERVED',
  VEHICLE_RESERVED_CONGRATS: 'VEHICLE_RESERVED_CONGRATS',
  NONE: 'NONE',
};

export const useCTATypes = ({ isAtYourDoor }: UseCTATypesInputProps): UseCTATypesProps => {
  const { firstButtonType, secondButtonType, legalTextType }: UseCTATypesProps = useMemo(() => {
    // for USA market

    // pipeline vehicles

    // for Tier 3
    if (IS_T3_WEBSITE)
      return {
        firstButtonType: FIRST_BUTTON_TYPES.VISIT_DEALER_LISTING,
        secondButtonType: SECOND_BUTTON_TYPES.CONTACT_DEALER,
        legalTextType: BUTTON_LEGAL_NOTES.NONE,
      };

    // if Vehicle is already sold
    // if (isSold)
    //   return {
    //     firstButtonType: FIRST_BUTTON_TYPES.REQUEST_A_QUOTE,
    //     secondButtonType: SECOND_BUTTON_TYPES.RESERVED,
    //     legalTextType: BUTTON_LEGAL_NOTES.VEHICLE_RESERVED,
    //   };

    // e-deposite eligible
    // if (MARKET !== 'CAN' && !isAvailableNow && isPipeline && showPlaceEDepositButton)
    //   return {
    //     firstButtonType: FIRST_BUTTON_TYPES.VISIT_DEALER_LISTING,
    //     secondButtonType: SECOND_BUTTON_TYPES.PLACE_E_DEPOSIT,
    //     legalTextType: BUTTON_LEGAL_NOTES.PLACE_E_DEPOSIT,
    //   };

    // e-deposite eligible but reserved
    // if (MARKET !== 'CAN' && !isAvailableNow && isPipeline && !showPlaceEDepositButton)
    //   return {
    //     firstButtonType: FIRST_BUTTON_TYPES.REQUEST_A_QUOTE,
    //     secondButtonType: SECOND_BUTTON_TYPES.RESERVED,
    //     legalTextType: showCongratulationsText
    //       ? BUTTON_LEGAL_NOTES.VEHICLE_RESERVED_CONGRATS
    //       : BUTTON_LEGAL_NOTES.VEHICLE_RESERVED,
    //   };

    // for OLS eligible dealers
    // if (showOnlineShoppingCTAS && MARKET === 'USA')
    //   return {
    //     firstButtonType: FIRST_BUTTON_TYPES.START_ONLINE_SHOPPING,
    //     secondButtonType: SECOND_BUTTON_TYPES.REQUEST_A_QUOTE,
    //     legalTextType: BUTTON_LEGAL_NOTES.NONE,
    //   };

    // for CAN market

    // if (MARKET === 'CAN' && !isAvailableNow && isPipeline && showPlaceEDepositButton)
    //   return {
    //     firstButtonType: FIRST_BUTTON_TYPES.REQUEST_A_QUOTE,
    //     secondButtonType: SECOND_BUTTON_TYPES.PLACE_E_DEPOSIT,
    //     legalTextType: BUTTON_LEGAL_NOTES.PLACE_E_DEPOSIT,
    //   };

    // if (MARKET === 'CAN' && !isAvailableNow && isPipeline && !showPlaceEDepositButton)
    //   return {
    //     firstButtonType: FIRST_BUTTON_TYPES.REQUEST_A_QUOTE,
    //     secondButtonType: SECOND_BUTTON_TYPES.RESERVED,
    //     legalTextType: showCongratulationsText
    //       ? BUTTON_LEGAL_NOTES.VEHICLE_RESERVED_CONGRATS
    //       : BUTTON_LEGAL_NOTES.VEHICLE_RESERVED,
    //   };

    if (MARKET === 'CAN')
      return {
        firstButtonType: FIRST_BUTTON_TYPES.BOOK_A_TEST_DRIVE,
        secondButtonType: SECOND_BUTTON_TYPES.CONTACT_DEALER,
        legalTextType: BUTTON_LEGAL_NOTES.NONE,
      };

    // Visit Dealer

    if (isAtYourDoor)
      return {
        firstButtonType: FIRST_BUTTON_TYPES.REQUEST_A_QUOTE,
        secondButtonType: SECOND_BUTTON_TYPES.VISIT_DEALER_LISTING,
        legalTextType: BUTTON_LEGAL_NOTES.NONE,
      };

    return {
      firstButtonType: FIRST_BUTTON_TYPES.REQUEST_A_QUOTE,
      secondButtonType: SECOND_BUTTON_TYPES.VISIT_DEALER_LISTING,
      legalTextType: BUTTON_LEGAL_NOTES.NONE,
    };
  }, [isAtYourDoor]);

  return { firstButtonType, secondButtonType, legalTextType };
};
